import { render, staticRenderFns } from "./PageTrades.vue?vue&type=template&id=3bdcf239"
import script from "./PageTrades.vue?vue&type=script&lang=js"
export * from "./PageTrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports